import { Box3, Mesh } from 'three';

/**
 * The single source of truth for buildings. Both the physics collider and the
 * web-targeting raycaster read from here, so they can never disagree about
 * where a building is. (Decouples "what buildings exist" from the systems that
 * consume them — Dependency Inversion in spirit.)
 */
export class BuildingRegistry {
  /** Axis-aligned bounding boxes, used for fast player collision. */
  readonly boxes: Box3[] = [];
  /** Meshes, used as raycast targets when firing a web. */
  readonly meshes: Mesh[] = [];

  add(mesh: Mesh): void {
    this.meshes.push(mesh);
    this.boxes.push(new Box3().setFromObject(mesh));
  }
}
